import TransactionsPage from './TransactionsPage'
import { transactionsMenu } from './sideBarOption'

export { transactionsMenu }
export default TransactionsPage
